import {
  DirectDepositDialog,
  DirectDepositDialogParams,
} from 'client/modules/collateral/deposit/components/DirectDepositDialog';

// Funkit not supported on Stack'd Perps — use direct deposit dialog.
export function DepositDialogWithFunkit(
  directDepositDialogProps: DirectDepositDialogParams,
) {
  return <DirectDepositDialog {...directDepositDialogProps} />;
}
